import type { ReactNode } from "react";
import { useSelector } from "react-redux";
import {
  getTableTotalAmount,
  getTableTotalData,
} from "@fas/cpa-state-manager/services/selectors";
import type { StoreWithTable } from "@fas/cpa-state-manager/services/selectors";
import Body from "@fas/cpa-cabinet-ui/lib/Table/Body";
import React from "react";
import { useReportTable } from "../../hooks";
import { MAIN_REPORT_TABLE } from "../../constants";
import { mainReportColumnsMap } from "./mainReportColumnsMap";

function TotalMain({ classes }: any) {
  const data: any = useSelector((state: any): any =>
    getTableTotalData(state, MAIN_REPORT_TABLE)
  );
  const count: number = useSelector((state: StoreWithTable): number =>
    getTableTotalAmount(state, MAIN_REPORT_TABLE)
  );
  const { columns, isLoading }: any = useReportTable({
    columnsMap: {
      ...mainReportColumnsMap,
      date: {
        field: "date",
        label: "",
        render: (): any => "Total",
      },
      country: {
        field: "country",
        label: "",
        render: (): any => "Total",
      },
      subId: {
        field: "subId",
        label: "",
        render: (): any => "Total",
      },
      smartlink_name: {
        field: "smartlink_name",
        label: "",
        render: (): any => "Total",
      },
    },
    tableKey: "MAIN_REPORT_TABLE",
  });
  if (isLoading || !count) return null;
  return <Body columns={columns} data={[data]} classes={classes} />;
}

export default TotalMain;
